import { useCallback } from "react";
import { usePaywall } from "@/contexts/PaywallContext";
import type { PaymentError } from "@/lib/quotaError";

/**
 * V4.4 — single UX router for a parsed 402 PaymentError:
 *   - quota_exceeded scope:"daily"   → global PaywallSheet, daily copy +
 *     placement "daily_limit". Founder decision: hitting the daily cap is the
 *     PEAK-INTENT moment — the old soft "volta amanhã" toast (V4.3 / PR #263)
 *     threw the sale away (D1≈0%, "tomorrow" never comes). Full upsell, no
 *     free-tomorrow escape button; the sheet's standard X/close remains
 *     (dismissing does NOT unlock message #11).
 *   - quota_exceeded scope:"monthly" → global PaywallSheet (unchanged)
 *   - module_locked                  → global PaywallSheet (module copy)
 *
 * No session dedup — re-opening the sheet on each blocked send is intended.
 */
export function usePaymentErrorHandler() {
  const { openPaywall } = usePaywall();

  return useCallback(
    (err: PaymentError) => {
      if (err.type === "module_locked") {
        openPaywall({ variant: "module_locked", moduleId: err.module });
        return;
      }
      if (err.scope === "daily") {
        openPaywall({
          variant: "quota_exceeded",
          quotaKind: err.kind,
          quotaScope: "daily",
          placement: "daily_limit",
          periodEnd: err.periodEnd,
          currentTier: err.currentTier,
        });
        return;
      }
      // period_end + current_tier (LOTE 3): o 402 sempre os trouxe; o sheet
      // passa a usá-los para o LIVE — Premium sem minutos vê QUANDO renova
      // em vez do upsell de Premium que já é dele.
      openPaywall({
        variant: "quota_exceeded",
        quotaKind: err.kind,
        quotaScope: "monthly",
        periodEnd: err.periodEnd,
        currentTier: err.currentTier,
      });
    },
    [openPaywall],
  );
}
